import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantReviewPage = {
  footer: {
    root: 'coapplicant-review-page.footer.root',
  },
  form: {
    h1: 'coapplicant-review-page.form.h1',
    h2: 'coapplicant-review-page.form.h2',
    root: 'coapplicant-review-page.form.root',
    submitButton: 'coapplicant-review-page.form.submit-button',
  },
  header: {
    drawerButton: 'coapplicant-review-page.header.drawer-button',
    previousStepButton: 'coapplicant-review-page.header.previous-step-button',
    root: 'coapplicant-review-page.header.root',
  },
  progress: {
    root: 'coapplicant-review-page.progress.root',
  },
} as const satisfies PageLocatorMap;
